import { Box } from "@mui/material";

export default function FolderColorItem(props: {
    color: string;
    selected: boolean;
    onSelected: (color: string) => void;
}) {
    return (
        <Box
            onClick={() => props.onSelected(props.color)}
            sx={{
                bgcolor: `#${props.color}`,
                cursor: "pointer",
                width: 25,
                height: 25,
                borderRadius: "4px",
                transform: props.selected ? "scale(1.2,1.2)" : "default",
            }}
        />
    );
}
